// extracted by mini-css-extract-plugin
export default {"pdf_container":"file-viewer-controller_pdf_container__L8y2z"};